import styled from 'styled-components';

import Heading from '../Heading/Heading.styled';
import Paper from '../Paper/Paper.styled';

export const FootprintSummaryWrapperStyled = styled(Paper)`
  padding: 20px 15px;
`;

export const EquivalentListStyled = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 20px 5px;

  li {
    display: flex;
    flex-direction: column;
    align-items: center;

    flex: 1;
  }
`;

export const ImageWrapperStyled = styled.div`
  border: 1px solid #ac8364;
  width: 125px;
  height: 125px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EquivalentLabelStyled = styled.p`
  margin: 5px 0 0;
  text-align: center;

  ${({ theme }) => `
    font-size: ${theme.fontSizes.medium};
  `}
`;

export const NumberStyled = styled(EquivalentLabelStyled)`
  ${({ theme }) => `
    font-weight: ${theme.fontWeights.semibold};  
    color: #000;
  `}
`;

export const Divider = styled.div`
  width: 65px;
  height: 2px;
  margin: 15px auto 35px;
  background: #ac8364;
`;

export const OffsetListStyled = styled.ul`
  margin-bottom: 40px;

  li {
    display: flex;
    align-items: center;
    justify-content: space-between;

    ${({ theme }) => `
      font-weight: ${theme.fontWeights.medium};  
    `}

    & + li {
      border-top: 1px solid #d6d6d6;
      padding-top: 8px;
      margin-top: 8px;
    }

    &:last-child {
      margin-top: 35px;
      border-top: none;

      ${({ theme }) => `
        font-size: ${theme.fontSizes.medium};
      `}
    }
  }
`;

export const OffsetLabelStyled = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  text-transform: capitalize;
`;

export const TitleStyled = styled(Heading)`
  text-align: center;
  text-transform: capitalize;

  ${({ theme }) => `
    color: ${theme.textColour};
  `}
`;
